import styled from "styled-components/macro";

export const LockBoxOverlay = styled.div`
  position: absolute;
  top: 0;
  height: 29%;
  width: 100%;
  cursor: not-allowed;
`;

export const GrayBox = styled.div`
  background: var(--clr-settingsbg);
  /* height: 277px; */
  /* width: 100%; */

  height: 100%;
  width: 100%;
`;

export const UnlockContentBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

export const Title = styled.div`
  padding: 0.3em 0;
  /* font-size: 1.2rem; */
  font-size: 1rem;
`;

export const InputBox = styled.input`
  background: #202020;
  margin-top: 0.1em;
  /* border:  0.1em solid #686868; */
  /* border: 0.1em solid gold; */
  border: 0.1em solid ${(props) => (props.wrongPw ? "gold" : "#686868")};
  border-radius: 3px;
  width: 75%;
  padding: 0.25em 0;
  color: #edebeb;

  /* font-size: 1rem; */
  -webkit-text-security: disc;
  text-security: disc;
`;

export const WrongPwAlert = styled.div`
  color: gold;
  position: absolute;
  left: 36%;
  top: 43%;
`;

export const NumberContainer = styled.div`
  /* margin: 0.5rem 1rem; */
  margin-top: .25rem;
  margin-left: 1rem;
  margin-right: 1rem;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr 1fr;
  gap: 0.4em;
  /* width: 270px; */
  /* height: 210px; */
  /* height: 50%; */

  @media screen and (max-width: 767px) {
    /* gap: 0; */
    max-height: 130px;
  margin-top: .5rem;

  }

  & button {
    border: #414340;
    background: #686868;
    color: #edebeb;
    border-top-left-radius: 2px;
    border-bottom-left-radius: 2px;
    border-top-right-radius: 2px;
    border-bottom-right-radius: 2px;
    border-top-left-radius: 2px;
    border-bottom-left-radius: 2px;

    display: inline;
    font-size: 1.3rem;
    /* font-size: .7rem;  */
    padding: 0;

    @media screen and (max-width: 767px) {
      font-size: 1rem;
    }
  }
  & button.backspace {
    background-color: #404440;
  }

  & button.enter {
    background-color: #1074a0;
  }
`;

export const BackSpaceBtn = styled.button``;
